import { observer } from 'mobx-react-lite';
import React, { useEffect, useMemo, useState } from 'react';
import { deptOptions, ReportData } from './TimeSheet';
import agent from '../../../../app/api/agent';
import { toast } from 'react-toastify';
import { Button, Dropdown, Form, Icon, Loader, Table } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { Project } from './NFAITimeSheetWorkflow/types';
import { useStore } from '../../../../app/stores/store';
const NFAIProductivityReport = ({titleLoader,projectList}:{titleLoader:boolean,projectList: Project[]}) => {
   const { userStore } = useStore()

  const [loading, setLoading] = useState<boolean>(false);
  const [teamWise, setTeamWise] = useState<ReportData[]>([]);
  const [selectedDept, setSelectedDept] = useState<string>('');
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [employee,setEmployee] = useState("");
  const [title, setTitle] = useState("");
  
    
  useEffect(()=> {
    userStore.loadUsers();
    //eslint-disable-next-line
  },[])
    // Render helpers
    const projectOptions = useMemo(() => {
      return projectList.map((project) => ({
        key: project.id,
        value: project.id,
        text: project.name,
      }));
    }, [projectList]);

        const userListOptions = useMemo(() => {
        return userStore.userList.map((x, index) => ({
          key: index,
          value: x.displayName,
          text: x.displayName,
        }));
      }, [userStore.userList]);

  const handleChangeDept = async (
    e: React.SyntheticEvent<HTMLElement>,
    data: any,
  ) => {
    const newDept = data.value as string;
    setSelectedDept(newDept);
    setTeamWise([]);
  };

  const handleChangeEmp = async (
    e: React.SyntheticEvent<HTMLElement>,
    data: any,
  ) => {
    const newDept = data.value as string;
    setEmployee(newDept);
  };


  const handleChangeTitle = async (
    e: React.SyntheticEvent<HTMLElement>,
    data: any,
  ) => {
    const newDept = data.value as string;
    setTitle(newDept);
  };



  const calculateTotals = (
    data: ReportData[],
  ): { totalCompReel: number; totalHours: string } => {
    let totalCompReel = 0;
    let totalMinutes = 0;

    data.forEach((report) => {
      if (report.comp_Reel) {
        totalCompReel += parseFloat(String(report.comp_Reel));
      }
      if (report.total_Hours) {
        // Ensure total_Hours is a string before splitting
        const timeParts = String(report.total_Hours).split(':').map(Number);
        if (timeParts.length === 2) {
          const [hours, minutes] = timeParts;
          totalMinutes += hours * 60 + minutes;
        }
      }
    });

    // Convert total minutes back to hours and minutes
    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    const formattedTotalHours = `${totalHours}:${String(
      remainingMinutes,
    ).padStart(2, '0')}`;

    return { totalCompReel, totalHours: formattedTotalHours };
  };

  const handleViewReport = async () => {
    setLoading(true);
    try {
      //  const response = await agent.NFAIRestoTimeSheet.getTimeSheetByTeam(selectedDept);
      const startDateStr = moment(startDate).format('MM-DD-YYYY');
      const endDateStr = moment(endDate).format('MM-DD-YYYY');
      const payload = {
        StartDate: startDateStr,
        EndDate: endDateStr,
        department: selectedDept,
        ProjectId: title,
        EmpId: employee
      }
      const response = await agent.NFAIRestoTimeSheet.NFAIRestorationTimeSheet(payload);
      setTeamWise(response.data);
    } catch (error) {
      toast.error('Error fetching report data');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadReport = () => {
    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent +=
      'Date,Employee ID,Employee Name,Title,UCC ID,Batch,Total Reel,Total Scanned Frames,Total Duration,Rejection Minutes,No of Corrections,Types of Correction,Type of Film,Task,Scope of Work,Start Reel,End Reel,Comp Reel,Start Time,End Time,Total Hours,productionHours,Status,Remarks\n';
    teamWise.forEach((data) => {
      const row = `${data.date || ""},${data.emp_ID?.replace(/,/g, '|') || ""},${data.emp_Name?.replace(/,/g, '|') || ""},${data.title?.replace(/,/g, '|') || ""},${data.ucC_ID || ""},${data.batch|| ""},${data.total_Reel || ""},${data.total_Scanned_Frames || ""},${data.total_Duration || ""},${data.rejection_Minutes || ""},${data.no_of_Corrections?.replace(/,/g, '|') || ""},${data.types_of_Correction?.replace(/,/g, '|') || ""},${data.type_of_Film_BW_Color?.replace(/,/g, '|') || ""},${data.task?.replace(/,/g, '|') || ""},${data.scope_of_work?.replace(/,/g, '|') || ""},${data.start_Reel || ""},${data.end_Reel || ""},${data.comp_Reel || ""},${data.start_time || ""},${data.end_time || ""},${data.total_Hours || ""},${data.productionHours || ""},${data.status?.replace(/,/g, '|') || ""},${data.remarks?.replace(/,/g, '|') || ""}`;
      csvContent += row + '\n';
      //eslint-disable-next-line
    });
     const startDateStr = moment(startDate).format('MM-DD-YYYY');
      const endDateStr = moment(endDate).format('MM-DD-YYYY');
    const filename = () => {
      return `Team_${selectedDept}_StartDate_${startDateStr}_EndDate_${endDateStr}_Productivity_Report.csv`;
    };
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);  
    link.setAttribute('download', filename());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      style={{
        padding: '20px',
        transform: 'scale(0.90)',
        transformOrigin: 'top left',
      }}
    >
     <div
  style={loading ? {
    display: 'flex',
    alignItems: 'flex-end', // Aligns everything to the bottom for perfect baseline alignment
    marginBottom: '20px',
    flexWrap: 'wrap',
    gap: '10px', // Slightly larger gap for better spacing
    pointerEvents: 'none', 
    opacity: '0.6'
  } 
  :{
    display: 'flex',
    alignItems: 'flex-end', // Aligns everything to the bottom for perfect baseline alignment
    marginBottom: '20px',
    flexWrap: 'wrap',
    gap: '10px', // Slightly larger gap for better spacing
  }}
>
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', zIndex: 100 }}>
    <label style={{ fontWeight: 'bold', whiteSpace: 'nowrap', minWidth: '60px' }}>Team</label>
    <Dropdown
      clearable
      placeholder="Select an option"
      fluid
      search
      selection
      options={deptOptions}
      value={selectedDept}
      onChange={handleChangeDept}
      style={{ minWidth: '250px' }}
    />
  </div>

  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <label style={{ fontWeight: 'bold', whiteSpace: 'nowrap', minWidth: '90px' }}>Start Date</label>
    <div style={{ minWidth: '200px' }}>
      <Form style={{ zIndex: 100 }}>
      <DatePicker
        selected={startDate}
        onChange={(date: Date) => setStartDate(date)}
        dateFormat="dd-MM-yyyy"
        maxDate={new Date()}
        isClearable
        placeholderText="Select Start Date"
        wrapperClassName="datePicker" // Keep if you have custom class, but we'll use inline
        // Inline styles to match Semantic UI
        popperClassName="react-datepicker-popper"
        className="ui input" // Adds basic Semantic UI input class for border/radius
       
      />
      </Form>
    </div>
  </div>

  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <label style={{ fontWeight: 'bold', whiteSpace: 'nowrap', minWidth: '80px' }}>End Date</label>
    <div style={{ minWidth: '200px' }}>
      <Form style={{ zIndex: 100 }}>
      <DatePicker
        selected={endDate}
        onChange={(date: Date) => setEndDate(date)}
        dateFormat="dd-MM-yyyy"
        maxDate={new Date()}
        isClearable
        placeholderText="Select End Date"
        className="ui input"
      />
      </Form>
    </div>
  </div>
  
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', zIndex: 100 }}>
    <label style={{ fontWeight: 'bold', whiteSpace: 'nowrap', minWidth: '60px' }}>Title</label>
    <Dropdown
      clearable
      placeholder="Select an option"
      fluid
      search
      selection
      options={projectOptions}
      value={title}
      loading={titleLoader}
      onChange={handleChangeTitle}
      style={{ minWidth: '250px' }}
      disabled={!selectedDept || startDate === null || endDate ===  null}
    />
  </div>


  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', zIndex: 100 }}>
    <label style={{ fontWeight: 'bold', whiteSpace: 'nowrap', minWidth: '60px' }}>Employee</label>
    <Dropdown
      clearable
      placeholder="Select an option"
      fluid
      search
      selection
      options={userListOptions}
      value={employee}
      onChange={handleChangeEmp}
      style={{ minWidth: '250px' }}
      disabled={!selectedDept || startDate === null || endDate ===  null}
    />
  </div>


  <div style={{ display: 'flex', gap: '8px' }}>
    <Button primary onClick={handleViewReport} disabled={!selectedDept || startDate === null || endDate ===  null} style={{ width: "135px", }}>
      View Report
    </Button>
    <Button
      style={{ width: "26%", borderRadius: "6px" }}
      onClick={handleDownloadReport}
      disabled={teamWise.length === 0}
    >
      <Icon name="download" />
    </Button>
  </div>
</div>
      {loading ? (
        <Loader active inline="centered" />
      ) : (
        <div style={{ maxHeight: "890px" , minHeight: "500px" , overflowY: "auto", width: "112%", border: "1px solid #e9eaeb" }}>
          <Table celled striped style={{ fontSize: '12px' }}>
            <Table.Header style={{ position: 'sticky', top: 0, zIndex: 99 }}>
              <Table.Row>
                <Table.HeaderCell>S.No</Table.HeaderCell>
                <Table.HeaderCell>Date</Table.HeaderCell>
                <Table.HeaderCell>Employee ID</Table.HeaderCell>
                <Table.HeaderCell>Employee Name</Table.HeaderCell>
                <Table.HeaderCell>Title</Table.HeaderCell>
                <Table.HeaderCell>UCC ID</Table.HeaderCell>
                <Table.HeaderCell>Batch</Table.HeaderCell>
                <Table.HeaderCell>Total Reel</Table.HeaderCell>
                <Table.HeaderCell>Total Scanned Frames</Table.HeaderCell>
                <Table.HeaderCell>Total Duration</Table.HeaderCell>
                <Table.HeaderCell>Rejection Minutes</Table.HeaderCell>
                <Table.HeaderCell>No of Corrections</Table.HeaderCell>
                <Table.HeaderCell>Types of Correction</Table.HeaderCell>
                <Table.HeaderCell>Type of Film</Table.HeaderCell>
                <Table.HeaderCell>Task</Table.HeaderCell>
                <Table.HeaderCell>Scope of Work</Table.HeaderCell>
                <Table.HeaderCell>Start Reel</Table.HeaderCell>
                <Table.HeaderCell>End Reel</Table.HeaderCell>
                <Table.HeaderCell>Comp Reel</Table.HeaderCell>
                <Table.HeaderCell>Comp Reel Frames</Table.HeaderCell>
                <Table.HeaderCell>Comp Reel Duration</Table.HeaderCell>
                <Table.HeaderCell>Start Time</Table.HeaderCell>
                <Table.HeaderCell>End Time</Table.HeaderCell>
                <Table.HeaderCell>Total Hours</Table.HeaderCell>
                <Table.HeaderCell>Productivity</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell>Remarks</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {teamWise.length === 0 ? (
                <Table.Row>
                  <Table.Cell colSpan={22} textAlign="center">
                    No data available
                  </Table.Cell>
                </Table.Row>
              ) : (
                teamWise.length > 0 &&
                teamWise.map((report, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>{index + 1}</Table.Cell>
                    <Table.Cell>{report.date}</Table.Cell>
                    <Table.Cell>{report.emp_ID}</Table.Cell>
                    <Table.Cell>{report.emp_Name}</Table.Cell>
                    <Table.Cell>{report.title}</Table.Cell>
                    <Table.Cell>{report.ucC_ID}</Table.Cell>
                    <Table.Cell>{report.batch}</Table.Cell>
                    <Table.Cell>{report.total_Reel}</Table.Cell>
                    <Table.Cell>{report.total_Scanned_Frames}</Table.Cell>
                    <Table.Cell>{report.total_Duration}</Table.Cell>
                    <Table.Cell>{report.rejection_Minutes}</Table.Cell>
                    <Table.Cell>{report.no_of_Corrections}</Table.Cell>
                    <Table.Cell>{report.types_of_Correction}</Table.Cell>
                    <Table.Cell>{report.type_of_Film_BW_Color}</Table.Cell>
                    <Table.Cell>{report.task}</Table.Cell>
                    <Table.Cell>{report.scope_of_work}</Table.Cell>
                    <Table.Cell>{report.start_Reel}</Table.Cell>
                    <Table.Cell>{report.end_Reel}</Table.Cell>
                    <Table.Cell>{report.comp_Reel}</Table.Cell>
                    <Table.Cell>{report.comp_Reel_Frames}</Table.Cell>
                    <Table.Cell>{report.comp_Reel_Frames_Duration}</Table.Cell>
                    <Table.Cell>{report.start_time}</Table.Cell>
                    <Table.Cell>{report.end_time}</Table.Cell>
                    <Table.Cell>{report.total_Hours}</Table.Cell>
                    <Table.Cell>{report.productionHours}%</Table.Cell>
                    <Table.Cell>{report.status}</Table.Cell>
                    <Table.Cell>{report.remarks}</Table.Cell>
                  </Table.Row>
                ))
              )}
              {teamWise.length > 0 && (
                <Table.Row>
                  <Table.Cell style={{ textAlign: 'right' }} colSpan={14}>
                    <b>
                      Comp Reel Total: {calculateTotals(teamWise).totalCompReel}
                    </b>
                  </Table.Cell>
                  <Table.Cell style={{ marginLeft: '30px' }} colSpan={11}>
                    <b>Total Hours: {calculateTotals(teamWise).totalHours}</b>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </div>
      )}
    </div>
  );
};

export default observer(NFAIProductivityReport);
